import { Contact } from '../../../types/listing/contact';
import { saveContact } from '../../../api/glQueries';
import { postData } from '../../../api/glAxios';
import { ActionPayload } from '../../../types/common/action';

// constants
export const CONTACT_SAVED = 'CONTACT_SAVED';

// types
export type ContactSavedAction = ActionPayload<Contact> & {
    type: typeof CONTACT_SAVED
};

export const contactSaved = (payload: Contact): ContactSavedAction => ({
    type: CONTACT_SAVED,
    payload
});

// thunk
export const saveContactFromModal = (contact: Contact, regionId?: string) => (dispatch: Function): Promise<Contact> => {

    return new Promise((resolve, reject) => {
        postData(saveContact(contact, regionId)).then((result: any) => {
            if(!result.data || !result.data.saveContact){
                reject("There was an error saving this contact.");
            }else{
                const savedContact: Contact = result.data.saveContact;
                dispatch(contactSaved(savedContact));
                resolve(savedContact);
            }
        }).catch((error:any) => {
            reject("There was an error saving this contact.");
        });
    });    
}
